<div class="loading-spinner">
  <img src="assets/WG_logo.jpeg" class="zoom-in-out-box" alt="loading...">
</div>
